export { isHiddenUnderReportingLimit } from '@oneclick/routing/reportingLimit';

/** Cluster Automation product nav — omit the whole section when reporting limits the console. */
export const CLUSTER_AUTOMATION_SECTION = {
  hiddenWhenReportingLimited: true,
} as const;
